var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticClass: "panel-group",
      attrs: { gutter: _vm.device == "mobile" ? 12 : 40 },
    },
    [
      _vm.device == "mobile"
        ? _c(
            "el-col",
            {
              staticClass: "card-panel-col",
              attrs: { xs: 24, sm: 24, md: 7, lg: 7 },
            },
            [
              _c(
                "div",
                {
                  staticClass: "card-panel",
                  staticStyle: {
                    "background-color": "transparent",
                    "box-shadow": "0 0 0 0",
                  },
                },
                [
                  _c("div", { staticClass: "avatar-upload-m" }, [
                    _c("div", { staticClass: "avatar-preview-m" }, [
                      _c("div", { staticClass: "avatar-edit-m" }, [
                        _c("input", {
                          attrs: {
                            type: "file",
                            id: "imageUpload",
                            accept: ".png, .jpg, .jpeg",
                          },
                          on: { change: _vm.previewFiles },
                        }),
                        _c("label", {
                          staticClass: "el-icon-edit",
                          staticStyle: { padding: "9px" },
                          attrs: { for: "imageUpload" },
                        }),
                      ]),
                      _c("div", {
                        style: {
                          "background-image":
                            "url(" +
                            (_vm.avatar ? _vm.avatar : _vm.emptyUserImg) +
                            ")",
                        },
                        attrs: { id: "imagePreview" },
                      }),
                    ]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-col",
        {
          staticClass: "card-panel-col",
          attrs: { xs: 6, sm: 12, md: 12, lg: 5 },
        },
        [
          _c("div", { staticClass: "card-panel" }, [
            _c(
              "div",
              { staticClass: "card-panel-icon-wrapper icon-shopping" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "shopping",
                    "class-name": "card-panel-icon",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "card-panel-description" },
              [
                _c("div", { staticClass: "card-panel-text" }, [
                  _vm._v(_vm._s(_vm.isFree ? "免費試用天數" : "系統開通狀態")),
                ]),
                _c("count-to", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isFree,
                      expression: "isFree",
                    },
                  ],
                  staticClass: "card-panel-num",
                  staticStyle: { color: "red" },
                  attrs: {
                    "start-val": 0,
                    "end-val": _vm.diffDays,
                    duration: 2000,
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isFree,
                        expression: "!isFree",
                      },
                    ],
                    staticStyle: {
                      color: "#13ce66",
                      "font-size": "16px",
                      padding: "2px 0",
                    },
                  },
                  [_vm._v("使用中")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-col",
        {
          staticClass: "card-panel-col",
          attrs: { xs: 6, sm: 12, md: 12, lg: 5 },
        },
        [
          _c("div", { staticClass: "card-panel" }, [
            _c(
              "div",
              { staticClass: "card-panel-icon-wrapper icon-people" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "peoples",
                    "class-name": "card-panel-icon",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "card-panel-description" },
              [
                _c("div", { staticClass: "card-panel-text" }, [
                  _vm._v("每年出團總人數"),
                ]),
                _c("count-to", {
                  staticClass: "card-panel-num",
                  attrs: {
                    "start-val": 0,
                    "end-val": _vm.perYearMemberCount,
                    duration: 2000,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-col",
        {
          staticClass: "card-panel-col",
          attrs: { xs: 6, sm: 12, md: 12, lg: 5 },
        },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("cc")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-message" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class": "message",
                      "class-name": "card-panel-icon",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("客服詢問次數"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.recordRequests,
                      duration: 2000,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "el-col",
        {
          staticClass: "card-panel-col",
          attrs: { xs: 6, sm: 12, md: 12, lg: 5 },
        },
        [
          _c(
            "div",
            {
              staticClass: "card-panel",
              on: {
                click: function ($event) {
                  return _vm.handleSetLineChartData("analysis")
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "card-panel-icon-wrapper icon-chart" },
                [
                  _c("svg-icon", {
                    staticClass: "chart-icon",
                    attrs: {
                      "icon-class": "chart",
                      "class-name": "card-panel-icon",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "card-panel-description" },
                [
                  _c("div", { staticClass: "card-panel-text" }, [
                    _vm._v("活動數據分析報告"),
                  ]),
                  _c("count-to", {
                    staticClass: "card-panel-num",
                    attrs: {
                      "start-val": 0,
                      "end-val": _vm.travelQtyByOver,
                      duration: 2000,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm.device != "mobile"
        ? _c("div", { staticClass: "avatar-upload" }, [
            _c("div", { staticClass: "avatar-edit" }, [
              _c("input", {
                attrs: {
                  type: "file",
                  id: "imageUpload",
                  accept: ".png, .jpg, .jpeg",
                },
                on: { change: _vm.previewFiles },
              }),
              _c("label", {
                staticClass: "el-icon-edit",
                staticStyle: { padding: "9px" },
                attrs: { for: "imageUpload" },
              }),
            ]),
            _c("div", { staticClass: "avatar-preview" }, [
              _c("div", {
                style: {
                  "background-image":
                    "url(" + (_vm.avatar ? _vm.avatar : _vm.emptyUserImg) + ")",
                },
                attrs: { id: "imagePreview" },
              }),
            ]),
          ])
        : _vm._e(),
      _c("travel-analysis-dialog", {
        attrs: { visible: _vm.travelAnalysisDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.travelAnalysisDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }